/* MOG MINTS, the contact page.
   The FAQ on this page is the home page's section, index-faq, rendered as it stands. Its
   accordions are native <details> and need nothing, but its question groups are a tablist and
   that behaviour lives in a script.

   WHY THIS IS A COPY. The same module already sits in index.js and product.js. theme.liquid
   routes one behaviour file per template, and index.js is the whole home page (the hero, the
   carousel, the formula scroll) which this page has no use for. The theme's own note on that
   case: each file was lifted from the matching page at the port and every module guards on its
   own root element. So this is the third copy of a module that was already duplicated, by that
   same rule. If a fourth page ever needs it, extract it to a shared asset and have all four
   load that instead.

   Lifted verbatim from index.js on 2026-09-16. If the tablist changes there, change it here.
*/
(function(){
  var nav = document.querySelector('.faq__nav'); if(!nav) return;
  var tabs  = [].slice.call(nav.querySelectorAll('[role="tab"]'));
  var panes = [].slice.call(document.querySelectorAll('.faq__grp'));

  function show(key, focus){
    tabs.forEach(function(t){
      var on = t.dataset.faq === key;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    panes.forEach(function(p){
      var on = p.dataset.faq === key;
      p.hidden = !on;
      /* leave the panel you are switching away from closed up. Coming back to a
         group and finding a panel you opened five minutes ago still hanging open
         reads as a bug, and it makes the two panes different heights. */
      if (!on) [].forEach.call(p.querySelectorAll('details[open]'), function(d){ d.open = false; });
    });
  }

  tabs.forEach(function(t){
    t.addEventListener('click', function(){ show(t.dataset.faq); });
  });

  nav.addEventListener('keydown', function(e){
    var i = tabs.indexOf(document.activeElement);
    if (i < 0) return;
    var n = null;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % tabs.length;
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') n = 0;
    else if (e.key === 'End') n = tabs.length - 1;
    if (n === null) return;
    e.preventDefault();
    show(tabs[n].dataset.faq, true);
  });
})();
